import { useLocale, useTranslations } from '@fshr/context/i18n-context';
import { languages, Language } from '@fshr/shared';

import Select from './select';

export default function LanguageSelect({
	onFocus,
	className,
}: {
	onFocus?: (evt: React.FocusEvent) => void;
	className?: string;
}) {
	const fsLocale = useLocale();
	const t = useTranslations();

	const options = [
		languages.find(language => language.fsLocale === fsLocale),
		...languages.filter(language => language.fsLocale !== fsLocale),
	]
		.filter(Boolean)
		.map(language => ({
			label: (language as Language).name,
			value: (language as Language).fsLocale,
			className: 'text-text-heading',
		}));

	return (
		<Select
			label={t('Select language')}
			wrapperClassName="pb-0 lg:pb-0"
			value={fsLocale}
			options={options}
			onFocus={onFocus}
			className={className}
		/>
	);
}
